import axios from 'axios'

export const PAYKUMO_FUNCTIONS_BASE = 'https://asia-east2-connextcc.cloudfunctions.net'

export function normalizePaykumoVisibleCodes (value) {
  const values = Array.isArray(value) ? value : String(value || '').split(',')
  return values
    .map(code => String(code || '').trim().toUpperCase())
    .filter(Boolean)
}

export function isPaykumoDepositAvailableForCode (config, userCode) {
  if (!config || config.enabled !== true || config.depositEnabled !== true || config.availableNow !== true) return false

  const codes = normalizePaykumoVisibleCodes(config.visibleToCodes)
  const normalizedUserCode = String(userCode || '').trim().toUpperCase()
  return codes.includes('*') || Boolean(normalizedUserCode && codes.includes(normalizedUserCode))
}

export async function fetchPaykumoPublicConfig () {
  const response = await axios.get(`${PAYKUMO_FUNCTIONS_BASE}/paykumoPublicConfig`, { timeout: 10000 })
  const payload = response && response.data
  if (!payload || !payload.success || !payload.data) {
    throw new Error('Paykumo public config response ไม่ถูกต้อง')
  }
  return payload.data
}
